import React from 'react'
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useState } from 'react';
import MyModal from '../../../../../../../../UI/modal/MyModal';
import { Tooltip } from '@mui/material';
import AgreeHeaderBillItemAllForm from './AgreeHeaderBillItemForm';

const AgreeHeaderAllButton = ({ supplyBillId, supplyBillItems }) => {

    const [open, setOpen] = useState(false)

  return (
    <>
        {/* <SupplyBillAgreeIco
            onClick={e => setOpen(true)}
            text={'Погодження керівником'}
            ico={<VisibilityIcon />}
            value={supplyBillItem.isAgreeLeadership}
        /> */}
        <Tooltip
            title={'Погодження керівником'}
            onClick={e => setOpen(true)}
        >
            <VisibilityIcon />
        </Tooltip>

        <MyModal
            open={open}
            setOpen={setOpen}
            header={'Погодження'}
            disableClickOutside={true}
            content={
                <AgreeHeaderBillItemAllForm
                    supplyBillId={supplyBillId}
                    supplyBillItems={supplyBillItems}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default AgreeHeaderAllButton